import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';
import { useTranslation } from 'react-i18next';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const { t } = useTranslation();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-2xl font-heading font-bold text-foreground-950 mb-4">文章未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.category === article.category && a.id !== article.id)
    .slice(0, 3);

  return (
    <>
      <Navbar />
      <main className="pt-20 pb-16 bg-background-50">
        <article className="w-full px-4 md:px-6">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8 flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-500 cursor-pointer">{t('common:breadcrumb.home')}</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <Link to={`/category/${article.category}`} className="hover:text-primary-500 cursor-pointer">{article.categoryName}</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-800 line-clamp-1">{article.title}</span>
          </nav>

          <div className="max-w-4xl mx-auto">
            <div className="mb-8">
              <span className="inline-block text-xs font-medium text-primary-500 bg-primary-500/8 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
                {article.categoryName}
              </span>
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 leading-tight">
                {article.title}
              </h1>
              <div className="flex items-center gap-4 text-sm text-foreground-500 flex-wrap">
                <span className="flex items-center gap-1"><i className="ri-user-line"></i>{article.author}</span>
                <span className="flex items-center gap-1"><i className="ri-calendar-line"></i>{article.publishDate}</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{article.viewCount.toLocaleString()} 阅读</span>
                <span className="flex items-center gap-1"><i className="ri-message-2-line"></i>{article.commentCount.toLocaleString()} 评论</span>
              </div>
            </div>

            <div className="mb-10 rounded-xl overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                title={`爆料网 - ${article.title}`}
                className="w-full h-auto object-cover object-top max-h-[500px]"
              />
            </div>

            <div className="flex flex-wrap gap-2 mb-10">
              {article.tags.map((tag) => (
                <span key={tag} className="text-xs bg-secondary-100 text-secondary-800 px-3 py-1 rounded-full whitespace-nowrap">{tag}</span>
              ))}
            </div>

            <div className="prose prose-lg max-w-none mb-12">
              <p className="text-lg text-foreground-700 leading-relaxed mb-6">
                {article.excerpt}
              </p>
              <p className="text-foreground-600 leading-relaxed mb-4">
                据知情人士向爆料网独家透露，此事在圈内早已不是秘密。多位不愿具名的业内人士在接受采访时表示，类似的情况在娱乐圈并不罕见，只是这次恰巧被曝光了出来。
              </p>
              <p className="text-foreground-600 leading-relaxed mb-4">
                爆料网记者经过多方核实，已从至少三个独立渠道获得证实。目前相关当事人暂未对此事作出公开回应，但其团队已紧急启动公关程序，试图控制事态发展。
              </p>
              <p className="text-foreground-600 leading-relaxed mb-4">
                值得注意的是，这已经不是第一次有业内人士站出来揭露类似问题。早在去年就有相关传闻在网络流传，但当时并未引起广泛关注。这次事件的特殊之处在于爆料方提供了大量翔实的证据材料，使得事件的可信度大幅提升。
              </p>
              <p className="text-foreground-600 leading-relaxed mb-4">
                爆料网将持续关注此事进展，并在获得更多可靠信息后第一时间为读者带来独家深度报道。同时我们呼吁广大网友理性看待网络信息，不传谣不信谣，一切以权威部门的最终调查结果为准。
              </p>
              <p className="text-foreground-600 leading-relaxed">
                以上内容为爆料网独家整理报道，未经许可严禁转载。如需转载请联系爆料网编辑部获取授权。
              </p>
            </div>
          </div>

          {relatedArticles.length > 0 && (
            <div className="max-w-4xl mx-auto mt-16 pt-12 border-t border-background-200/70">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">相关爆料</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.slug}`}
                    className="group block cursor-pointer"
                  >
                    <div className="relative h-40 rounded-lg overflow-hidden mb-3">
                      <img
                        src={ra.coverImage}
                        alt={ra.title}
                        title={`爆料网 - ${ra.title}`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <h3 className="text-sm font-heading font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                      {ra.title}
                    </h3>
                    <span className="text-xs text-foreground-400">{ra.publishDate}</span>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </article>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Article',
              headline: article.title,
              description: article.excerpt,
              image: article.coverImage,
              author: {
                '@type': 'Person',
                name: article.author,
              },
              datePublished: article.publishDate,
              publisher: {
                '@type': 'Organization',
                name: t('common:site.name'),
              },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: t('common:breadcrumb.home'),
                  item: 'http://baoliao91.cn/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: article.categoryName,
                  item: `http://baoliao91.cn/category/${article.category}`,
                },
                {
                  '@type': 'ListItem',
                  position: 3,
                  name: article.title,
                },
              ],
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}